export class SelectOption {
  public key?: string = '';
  public label: string = '';
  public value: any = '';
  public color?: string;
  public image?: string;

  constructor(label: any = '', value: any = '', key: string = '') {
    this.label = label;
    this.value = value;
    this.key = key;
  }
}
